<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center">
        <v-button
          icon="home"
          style-type="link"
          type="button"
          @click="$router.push({name: 'admin-dashboard'})"
        />
        <h3 class="m-0">
          {{ $tc('word.item', 2) }}
          <small class="text-muted">({{ totalObjects }})</small>
        </h3>
      </div>
      <form class="d-flex" method="post" @submit.prevent="filterObjects(searchQuery)">
        <div class="mr-2">
          <v-text-input
            id="item-list-search"
            v-model="searchQuery"
            placeholder="word.search"
          />
        </div>
        <div>
          <v-button
            icon="search"
            style-type="secondary"
            type="submit"
          />
        </div>
      </form>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="loading"
    >
      <v-loader
        :small="false"
      />
    </div>
    <table
      v-else-if="objectList.length > 0"
      class="table table-hover"
    >
      <thead>
      <th>{{ $t('word.title') }}</th>
      <th>{{ $t('word.render_type') }}</th>
      <th>{{ $tc('word.organisation', 1) }}</th>
      <th>{{ $tc('word.answer', 2) }}</th>
      <th>{{ $tc('word.research', 2) }}</th>
      <th>#</th>
      </thead>
      <tbody>
      <tr v-for="item in objectList" :key="item.id">
        <td>
          <router-link
            :to="{name: 'admin-item-detail', params: {id: item.id}}"
          >
            {{ item.title }}
          </router-link>
        </td>
        <td>
          <div class="badge bg-cr-red-black text-white">
            {{ item.render_type.replace('_', ' ') }}
          </div>
        </td>
        <td>
          <span v-if="item.organisation">{{ item.organisation.name }}</span>
        </td>
        <td>
          <span
            class="badge text-white"
            :class="item.answers_count > 0 ? 'bg-danger' : 'bg-success'"
          >
            {{ item.answers_count }}
          </span>
        </td>
        <td>
          <span
            class="badge text-white"
            :class="item.researches_count > 0 ? 'bg-danger' : 'bg-success'"
          >
            {{ item.researches_count }}
          </span>
        </td>
        <td>
          <div class="d-flex">
            <div class="mr-2">
              <v-button
                @click="mergeItem = item"
                style-type="secondary"
                icon="compress-alt"
                size="sm"
                :title="$t('word.merge')"
              />
            </div>
            <div>
              <a
                class="btn btn-secondary btn-sm"
                target="_blank"
                :href="`/admin/core/item/${item.id}/change/`"
              >
                <i class="fa fa-edit"></i>
              </a>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div
      v-else
      class="d-flex justify-content-center text-muted"
    >
      {{ $t('phrase.no_data_found') }}
    </div>
    <v-merge-items-modal
      v-if="mergeItem"
      :item-id="mergeItem.id"
      :render-type="mergeItem.render_type"
      @merged="reload"
    />
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import MergeItemsModal from '@/admin/components/MergeItemsModal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import { notify } from '@/common/utils/notify';

export default {
  name: 'ItemList',
  components: {
    'v-button': Button,
    'v-loader': Loader,
    'v-merge-items-modal': MergeItemsModal,
    'v-text-input': TextInput,
  },
  data() {
    return {
      apiPath: 'admin/items/',
      mergeItem: null,
      items: [],
    };
  },
  mixins: [GenericListMixin],
  methods: {
    reload() {
      this.mergeItem = null;
      this.filterObjects(this.searchQuery);
      notify(this.$t('phrase.items_merged'), this.$t('sentence.items_merged_successfully'));
    },
  },
};
</script>
